import React, { lazy } from 'react';
import { Navigate } from "react-router-dom"


// 404页面
const NotFound = lazy(() => import('@/components/NotFound/NotFound'))



// ResearchEquitis
const ResearchEquitis = lazy(() => import('@/views/Research/Equitis/Equitis'))
// ResearchBlog
const ResearchBlog = lazy(() => import('@/views/Research/Blog/Blog'))

// ResearchDisclaimer
const ResearchDisclaimer = lazy(() => import('@/views/Research/ResearchDisclaimer/ResearchDisclaimer'))










const routes = [
  // Home
  {
    path: '/',
    element: <Navigate to="/Research/Equities" />, // 重定向
  },
  // ResearchEquitis
  {
    path: '/Research/Equities',
    element: <ResearchEquitis />
  },
  // ResearchBlog
  {
    path: '/Research/EquitiesItem',
    element: <ResearchBlog />
  },

   // ResearchBlog
  {
    path: '/Research/Disclaimer',
    element: <ResearchDisclaimer />
  },


  // 404
  {
    path: '*',
    element: <NotFound />
  }
]


export default routes